export const copyToClipboard = async ({
  value,
  onSuccess,
  onFailure,
}: {
  value: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}) => {
  try {
    await navigator.clipboard.writeText(value);
    onSuccess?.();
  } catch (e) {
    onFailure?.();
  }
};
